<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <h3 v-if="editMemo.id">{{'Vorgabe bearbeiten'}}</h3>
              <h3 v-else>{{'Neuen Dienst anlegen'}}</h3>
               
               
              <div v-if="false">
                <!-- DEBUGG -->
                idCompany: {{editMemo.idCompany}}
                idUser: {{editMemo.idUserClient}}
              </div>
              
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form @keyup.esc="$emit('cancel', memo)" @submit.prevent="onSubmit" :id="_uid">
              <!-- <form @keyup.esc="$emit('cancel', memo)" :id="_uid"> -->
                
             
               <div class="form-group">
                  <label for="memo-text">Wer hat Dienst / Beschreibung:</label>
                  <textarea class="form-control" id="memo-text" rows="6" placeholder="Bitte eingeben..."  v-model="editMemo.text"></textarea>
                </div>
         
                <br>

                <div class="row form-group">
                  
                  <div class="col-sm-6 form-group">
                    <label for="memo-datetime-begin">Dienstbeginn</label>
                    <cc-datetime label_id="memo-datetime-begin" v-model="datetimeBegin"></cc-datetime>
                  </div>

                  <div class="col-sm-6 form-group">
                    <label for="memo-datetime-end">Dienstende:</label>
                    <cc-datetime label_id="memo-datetime-end" v-model="editMemo.datetimeEnd"></cc-datetime>
                  </div>   
                               
                </div>                


                
                <br>

               
              
              
              <!-- Vertreter -->
<!---              
              <user-client-typeahead @onHit="onAddAbsence"></user-client-typeahead>
               
                <div class="form-group">
                  <label for="memo-proxy">Vertreter:</label>
                  <div  style="margin-bottom: 15px" v-for="userClient in editMemo.userClientRef" >
                    <span class="tag label label-default">
                      <span>
                        {{userClient.firstName}} {{userClient.lastName}} {{userClient.department}} {{userClient.room}} {{userClient.function}}
                      </span>
                      <a>
                        <i 
                        @click="onRemoveAbsence(userClient)"  
                        class="remove glyphicon glyphicon-remove-sign glyphicon-white" 
                        title="Vertreter entfernen">
                        </i>
                      </a>
                    </span>
                  </div>
                </div>                
-->                
              <!-- END Vertreter -->
             
                               

                                
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="submit"
                :form="_uid"
                class="btn btn-primary">
                Speichern
              </button>

              <button type="" 
                class="btn btn-default"
                @click="$emit('cancel', memo)">
                Abbrechen
              </button>

              <button type="" 
                v-if="editMemo.id" 
                class="btn btn-danger"   
                @click="$emit('remove', memo)">
                Löschen
              </button>               
               
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

import MemoCommon from './common/memo.common'
import DateTime from './helper/datetime.vue'
import UserClientTypeahead from './UserClientTypeahead.vue'
import moment from 'moment'

export default {
  
  extends: MemoCommon,
  
  components: {
    'cc-datetime': DateTime,
    'user-client-typeahead': UserClientTypeahead,

  },  

  
  data () {
    return {
      editMemo: JSON.parse(JSON.stringify(this.memo)),
      datetimeBegin: ''
    }
  },
  
  created: function () {
    let tomorrow = moment().add(1, 'day').hour(8).minute(0);
    let dayAfterTomorrow = moment().add(2, 'day').hour(8).minute(0);

    this.datetimeBegin = tomorrow.format('YYYY-MM-DD HH:mm:ss')
    this.editMemo.datetimeBegin = this.datetimeBegin
    this.editMemo.datetimeEnd = dayAfterTomorrow.format('YYYY-MM-DD HH:mm:ss')
    this.editMemo.sorting = 99
  },
  
  computed: {
  },  
  
  watch: {
      datetimeBegin: function (val) {
        let iso = moment(val).add(1, 'day')
        this.editMemo.datetimeBegin = val
        this.editMemo.datetimeEnd = iso.format('YYYY-MM-DDTHH:mm')
      },
  },
  
  
  methods: {

    onAddAbsence: function (item) {
      this.editMemo.userClientRef.push(item);
    },

    onRemoveAbsence: function (item) {
      this.editMemo.userClientRef.splice(this.editMemo.userClientRef.indexOf(item.id), 1);
      console.log('onRemoveAbsence'+ item.id);
    },


    onSubmit: function () {
      if(_.isEqual(this.memo, this.editMemo)){
        // keine Änderung, speichern nicht notwendig
        this.$emit('cancel', this.memo)
      }else{
        // speichern
        this.editMemo.typ = 0;
        this.editMemo.text = this.editMemo.text;
        this.editMemo.summary = '';
        this.editMemo.headline = "Dienst";
        
        this.$emit('save', this.editMemo)
      }
    },
    
  },
}
  
</script>



<style scoped>
  
.tag {
  font-size: 14px;
  padding: .3em .4em .4em;
  margin: 0 .1em;
}
.tag a {
  color: #bbb;
  cursor: pointer;
  opacity: 0.6;
}
.tag a:hover {
  opacity: 1.0
}
.tag .remove {
  vertical-align: bottom;
  top: 0;
}
.tag a {
  margin: 0 0 0 .3em;
}
.tag a .glyphicon-white {
  color: #fff;
  margin-bottom: 2px;
} 
  .label-default{
    background-color: #bbb;    
  }  
  
 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80vh;
  /*margin: 0px auto;*/
  margin-left: 15%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  overflow: scroll;
  height:50vh;
  margin: 20px 0;
  padding-bottom: 50px;
}

.modal-footer {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid lightgray;
  text-align: right;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

  
input:invalid {
  border: 1px solid red;
}  
</style>



// WEBPACK FOOTER //
// MemoDienstModal.vue?78602596